import request from "@/utils/request";

export function handleListApi(data) {
    return request({
        url: "/admin/admin_view_permissions",
        method: "get",
        params: data
    });
}

export function handleCreateStoreApi(data) {
    if (data.id) {
        return request({
            url: "/admin/admin_view_permissions/" + data.id,
            method: "put",
            data
        });
    } else {
        return request({
            url: "/admin/admin_view_permissions",
            method: "post",
            data
        });
    }
}

export function handleDeleteApi(data) {
    return request({
        url: "/admin/admin_view_permissions/" + data.id,
        method: "delete"
    });
}

export function handleOrganListApi() {
    return request({
        url: "/admin/get_view_organ",
        method: "get"
    });
}

export function handleRoleListApi() {
    return request({
        url: "/admin/get_view_role",
        method: "get"
    });
}